import Room from '../../interfaces/room';

const FacilityData: Room[] = [
  {
    images: ['/images/interior/kitchen_1.jpg'],
    name: 'Large Kitchen',
    description:
      'Including stove, refrigerator, double sink, microwave oven, coffeemakers (one 10-cup and one 30-cup), four-slice toaster, & blender.',
  },
  {
    images: ['/images/interior/bedroom_siz_bunks.jpg'],
    name: 'Four Bedrooms',
    description:
      'One dorm room with 6 bunk beds; one room with 2 bunk beds and a queen bed; one room with a twin bed, a bunk bed and a double bed; another with a queen-size bed and a twin bed; a twin bed sits in an alcove in the hallway.',
  },
  {
    images: ['/images/interior/basement_apartment_1.jpg', '/images/interior/basement_apartment_2.jpg'],
    name: 'Basement Apartment',
    description: 'One king-size bed, a bunk bed and a twin bed, plus an unfinished family room with TV.',
  },
  {
    images: ['/images/interior/bathroom.jpg'],
    name: 'Four Bathrooms',
    description:
      'One next to the dorm room with two showers & two sinks; one near the other three bedrooms with a tub; one on the main floor with a shower; one in the apartment with a shower.',
  },
  {
    images: ['/images/interior/family_room.jpg'],
    name: 'Large Family Room',
    description: "16' × 25' with four couches (two open to queen-size beds), two chairs, and a T.V. & VCR with cable hook-up.",
  },
  {
    images: ['/images/interior/living_area_1.jpg'],
    name: 'Large Living Room',
    description: 'Two couches and three chairs with a TV & VCR/DVD, 3 computers, and a library of books, puzzles and games.',
  },
  {
    images: ['/images/interior/pantry_1.jpg'],
    name: 'Large Pantry',
    description: 'Cooking utensils, dishes, glasses, and silverware.',
  },
  {
    images: ['/images/interior/dining_room_1.jpg', '/images/interior/dining_room_2.jpg'],
    name: 'Dining Room',
    description: 'Seats up to 12 at a time — with extra chairs & a side table.',
  },
  {
    images: ['/images/interior/porch_1.jpg', '/images/interior/porch_2.jpg'],
    name: 'Two Large Porches',
    description: 'Great for eating out, sitting and relaxing.',
  },
  {
    images: ['/images/interior/parking_1.jpg', '/images/interior/parking_2.jpg'],
    name: 'Parking',
    description: 'Large parking area and 2 car garage.',
  },
  {
    images: ['/images/exterior/winterpic.jpg', '/images/exterior/fallpic.jpg'],
    name: 'Outdoor Amenities',
    description: 'There is a gas grill, fire pit, sleds, outdoor seating, etc. available for use.',
  },
];

export default FacilityData;
